'use client'

import { StaticPageForm } from '@/components/static-pages/StaticPageForm'
import { useToast } from '@/hooks/use-toast'
import apiClient from '@/lib/apiClient'
import type { StaticPageFormData } from '@/types/static-page'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const AddStaticPagePage: React.FC = () => {
  const { toast } = useToast()
  const navigate = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleFormSubmit = async (data: StaticPageFormData) => {
    setIsSubmitting(true)
    try {
      await apiClient.createStaticPage(data)
      toast({
        title: 'Success',
        description: 'Static page created successfully',
      })
      navigate('/static-pages')
    } catch {
      toast({
        title: 'Error',
        description: 'Failed to create static page. Please try again.',
        variant: 'destructive',
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleFormCancel = () => {
    navigate('/static-pages')
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Add Static Page</h1>
        <p className="text-muted-foreground">Create a new static content page</p>
      </div>

      <StaticPageForm
        page={null}
        onSubmit={handleFormSubmit}
        onCancel={handleFormCancel}
        isLoading={isSubmitting}
      />
    </div>
  )
}

export default AddStaticPagePage
